// src/features/user/AccountDashboard.jsx
import { useState } from "react";
import { useGetMeQuery } from "../../../features/api/userApiSlice";
import ProfileForm from "./ProfileForm";
import PasswordForm from "./PasswordForm";
import SubscriptionForm from "./SubscriptionForm";
import "./accountDashboard.scss";
import ActivityHistory from "./ActivitiesHistory";
import LoadingSpinner from "../../loader/Loader";
import NotificationsForm from "./NotificationsForm";

const AccountDashboard = () => {
  const { data: user, isLoading, error } = useGetMeQuery();
  const [tab, setTab] = useState("profile");

  if (isLoading) return <LoadingSpinner/>;
  if (error) return <p>Error loading account</p>;

  return (
    <div className="main_wrapper">
      <div className="account-dashboard">
        <h2>My Account</h2>

        <div className="tabs">
          <button
            className={tab === "profile" ? "active" : ""}
            onClick={() => setTab("profile")}
          >
            Profile
          </button>
          <button
            className={tab === "password" ? "active" : ""}
            onClick={() => setTab("password")}
          >
            Password
          </button>
          <button
            className={tab === "subscription" ? "active" : ""}
            onClick={() => setTab("subscription")}
          >
            Subscription
          </button>
          <button
            className={tab === "notifications" ? "active" : ""}
            onClick={() => setTab("notifications")}
          >
            Notifications
          </button>
          <button
            className={tab === "activity" ? "active" : ""}
            onClick={() => setTab("activity")}
          >
            Activity
          </button>
        </div>

        {tab === "profile" && <ProfileForm user={user} />}
        {tab === "password" && <PasswordForm />}
        {tab === "subscription" && (
          <SubscriptionForm subscription={user?.subscription} />
        )}
        {tab === "notifications" && <NotificationsForm />}
        {tab === "activity" && <ActivityHistory />}
      </div>
    </div>
  );
};

export default AccountDashboard;
